// DotLottie loaded via dynamic ESM import — no CDN dependency needed

const LOTTIE_URL_DESKTOP =
  'https://cdn.prod.website-files.com/695bba16060d8bdf2746bedc/699c35ab99537d4a96166e3b_Animaton-platform.lottie';
const LOTTIE_URL_MOBILE =
  'https://cdn.prod.website-files.com/695bba16060d8bdf2746bedc/699c35abc176a9e6500f7607_mobile-platform.lottie';
const TOTAL_FRAMES = 800;

function createCanvas(parentEl) {
  const canvas = document.createElement('canvas');
  canvas.style.width = '100%';
  canvas.style.height = '100%';
  parentEl.appendChild(canvas);
  return canvas;
}

export async function initPlatformLottie() {
  const section = document.querySelector('.platform-sticky');
  if (!section) return;

  const desktopWrap = document.querySelector('.platform-lottie.is--desktop');
  const mobileWrap = document.querySelector('.platform-lottie.is--mobile');
  if (!desktopWrap && !mobileWrap) return;

  const { DotLottie } =
    await import('https://cdn.jsdelivr.net/npm/@lottiefiles/dotlottie-web/+esm');

  const instances = [];

  if (desktopWrap) {
    const canvas = createCanvas(desktopWrap);
    instances.push(
      new DotLottie({
        canvas,
        src: LOTTIE_URL_DESKTOP,
        autoplay: false,
        loop: false,
      })
    );
  }

  if (mobileWrap) {
    const canvas = createCanvas(mobileWrap);
    instances.push(
      new DotLottie({
        canvas,
        src: LOTTIE_URL_MOBILE,
        autoplay: false,
        loop: false,
      })
    );
  }

  // Wait for ALL instances to load before setting up ScrollTrigger
  await Promise.all(
    instances.map((lottie) => new Promise((resolve) => lottie.addEventListener('load', resolve)))
  );

  let lastFrame = -1;

  ScrollTrigger.create({
    trigger: section,
    start: 'top top',
    end: 'bottom+=6000 bottom',
    pin: true,
    scrub: 1,
    invalidateOnRefresh: true,
    onUpdate: (self) => {
      const frame = Math.round(self.progress * TOTAL_FRAMES);
      if (frame === lastFrame) return;
      lastFrame = frame;
      instances.forEach((lottie) => lottie.setFrame(frame));
    },
  });

  ScrollTrigger.refresh();
}
